import { AfterViewInit, Component, ElementRef, HostListener, Inject, isDevMode, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

import { RoleAdm, ROUTES, TITLE } from './app-config';
import { AuthToken } from './models/auth-token';
import { NavRoute } from './models/nav.route';
import { AuthService } from './services/auth.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { TokenService } from './services/token.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DialogPerfilUsuarioComponent } from './components/dialog-perfil-usuario/dialog-perfil-usuario.component';
import { ModoExibicaoPersistidoService } from './services/modo-exibicao-persistido.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterViewInit, OnDestroy, OnInit {
	@ViewChild('menuItems') private menuItems?: ElementRef<HTMLElement>;
  public title = TITLE;
  public routes$ = new BehaviorSubject<readonly NavRoute[] | null>(null);
  public name?:string;
  public redAlert = isDevMode();
  public fotoPerfilDisponivel = true;
  public fotoPerfilVersao = Date.now();
  public isAdministrador = false;
  private subscription;
	private menuScrollTimer?: number;
  private firstSegment?: string;
  public activeSubmenu: boolean = false;
  public isMenuclose = false;
  public selectedRoute: string | null = null;
	public podeRolarMenuParaCima = false;
	public podeRolarMenuParaBaixo = false;
	public podeRolarMenuParaEsquerda = false;
	public podeRolarMenuParaDireita = false;

  constructor(
    public titleService: Title,
    private authService: AuthService,
    private readonly tokenService: TokenService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private modoExibicaoPersistidoService: ModoExibicaoPersistidoService
  ) {
    titleService.setTitle(this.title);
    this.modoExibicaoPersistidoService.iniciar();
    
    this.subscription = this.tokenService
      .getTokenUserCredentials()
      .subscribe((token) =>
        this.tokenService
          .decodeToken(token)
          .subscribe((authToken) => this.onTokenChange(authToken))
    );
  }
  ngOnInit(): void {
    this.activatedRoute.params.subscribe(() => {
      const url = window.location.href;
      const segments = url.split('/');
      this.firstSegment = segments[3];

      const route = ROUTES.find(
        (route) => route.route === this.firstSegment
      );
      if (route?.isParent) {
        this.activeSubmenu = true;
      }
    });
  }
  ngAfterViewInit(): void {
		setTimeout(() => this.atualizarSetasMenu());
	}

	@HostListener('window:resize')
	onWindowResize(): void {
		this.atualizarSetasMenu();
	}

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
		this.pararRolagemMenu();
  }

  public onClickSistemas() {
    location.href = environment.sistemasUrl;
  }

  private onTokenChange(token?:AuthToken) {
    this.isAdministrador = AuthService.canTokenActivate(token, [RoleAdm]);
    if (token) {
      const route = ROUTES.filter((route) =>
        AuthService.canTokenActivate(token, route.authLevel)
      );

      if (
        !this.routes$.getValue() ||
        this.routes$.getValue()!.length !== route.length
      ) {
        this.name = token.actor;
        this.routes$.next(route);
		setTimeout(() => this.atualizarSetasMenu());
      }
    } else {
      this.routes$.next(null);
      this.name = undefined;
    }
  }
  
  public onSair() {
    this.isAdministrador = false;
    this.routes$.next(null);
    this.authService.logout();
  }

  public isRouteActive(route: NavRoute): boolean {
    const currentRoute = this.router.url.split(/[?#]/)[0].replace(/^\//, '');
    const activeRoutes = [route.route, ...(route.activeRoutes ?? [])];

    return activeRoutes.some(activeRoute =>
      currentRoute === activeRoute || currentRoute.startsWith(`${activeRoute}/`)
    );
  }

  public abrirMenuPerfil(): void {
    if (!this.name) {
      return;
    }

    this.dialog.open(DialogPerfilUsuarioComponent, {
      autoFocus: false,
      disableClose: true,
      panelClass: 'dialog-meu-perfil-painel',
      width: '360px',
      maxWidth: 'calc(100vw - 32px)',
      position: { right: '20px', top: '99px' },
      data: { nome: this.name, administrador: this.isAdministrador }
    }).afterClosed().subscribe((perfil?: { nome?: string; sair?: boolean; fotoAlterada?: boolean }) => {
      if (perfil?.nome) this.name = perfil.nome;
      if (perfil?.fotoAlterada) {
        this.fotoPerfilDisponivel = true;
        this.fotoPerfilVersao = Date.now();
      }
      if (perfil?.sair) this.onSair();
    });
  }

  public onErroFotoPerfil(): void {
    this.fotoPerfilDisponivel = false;
  }

  public iniciaisUsuario(): string {
    return (this.name ?? '?').trim().split(/\s+/).slice(0, 2).map(nome => nome[0]).join('').toUpperCase();
  }

  public iniciarRolagemMenu(direcao: 1 | -1): void {
		this.pararRolagemMenu();

		const menu = this.menuItems?.nativeElement;
		if (!menu) {
			return;
		}

		let velocidade = 0.5;
		this.menuScrollTimer = window.setInterval(() => {
			const limite = menu.scrollHeight - menu.clientHeight;
			const proximaPosicao = Math.max(0, Math.min(limite, menu.scrollTop + (direcao * velocidade)));
			menu.scrollTop = proximaPosicao;
			const atingiuLimite = direcao === -1
				? menu.scrollTop <= 1
				: menu.scrollTop + menu.clientHeight >= menu.scrollHeight - 1;

			if (atingiuLimite) {
				this.pararRolagemMenu();
				this.atualizarSetasMenu();
				return;
			}

			velocidade = Math.min(velocidade + 0.35, 10);
		}, 16);
	}

	public pararRolagemMenu(): void {
		if (this.menuScrollTimer !== undefined) {
			window.clearInterval(this.menuScrollTimer);
			this.menuScrollTimer = undefined;
		}
	}

	public iniciarRolagemMenuHorizontal(direcao: 1 | -1): void {
		this.pararRolagemMenu();

		const menu = this.menuItems?.nativeElement;
		if (!menu) {
			return;
		}

		let velocidade = 0.5;
		this.menuScrollTimer = window.setInterval(() => {
			const limite = menu.scrollWidth - menu.clientWidth;
			const proximaPosicao = Math.max(0, Math.min(limite, menu.scrollLeft + (direcao * velocidade)));
			menu.scrollLeft = proximaPosicao;
			const atingiuLimite = direcao === -1
				? menu.scrollLeft <= 1
				: menu.scrollLeft + menu.clientWidth >= menu.scrollWidth - 1;

			if (atingiuLimite) {
				this.pararRolagemMenu();
				this.atualizarSetasMenu();
				return;
			}

			velocidade = Math.min(velocidade + 0.35, 10);
		}, 16);
	}

	public atualizarSetasMenu(): void {
		const menu = this.menuItems?.nativeElement;
		if (!menu) {
			return;
		}

		this.podeRolarMenuParaCima = menu.scrollTop > 1;
		this.podeRolarMenuParaBaixo = menu.scrollTop + menu.clientHeight < menu.scrollHeight - 1;
		this.podeRolarMenuParaEsquerda = menu.scrollLeft > 1;
		this.podeRolarMenuParaDireita = menu.scrollLeft + menu.clientWidth < menu.scrollWidth - 1;
	}
  
  public toggleMenu() {
    this.isMenuclose = !this.isMenuclose;
    const menu = document.querySelector('.menu');
    if (menu) {
      menu.classList.toggle('close', this.isMenuclose);
    }
  }

  public toggleChildren(route: NavRoute) {
    if (this.selectedRoute === route.route) {
      route.arrowIcon = "arrow_right";
      this.selectedRoute = null;
    } else {
      this.routes$?.forEach(r => r![0].arrowIcon = "arrow_right");
      route.arrowIcon = "arrow_drop_down";
      this.selectedRoute = route.route;
    }
  }

}
